import React, { useState, useEffect } from "react";
import { Modal, Input, Form, Row, Col, Typography } from "antd";

const { Item } = Form;
const { Text, Title } = Typography;

const CountryForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(props.editable);

  const { form, open, close, data, modify, emitData } = props;
  const { getFieldDecorator, setFieldsValue, resetFields, validateFields } = form;

  useEffect(() => {
    setEditable(props.editable);
    if (data) {
      setFieldsValue({
        name: data.name,
        sortName: data.sortName,
        phoneCode: data.phoneCode,
      });
    }
  }, [data, props.editable]);

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        const payload = {
          name: values.name.trim(),
          sortName: values.sortName ? values.sortName.trim() : "",
          phoneCode: values.phoneCode ? values.phoneCode.trim() : "",
        };
        if (data && data.id) {
          payload.id = data.id;
        }
        emitData(payload);
        setLoading(false);
        resetFields();
        close();
      }
    });
  };

  return (
    <Modal
      title={<Title level={4}>{data && data.id ? "Edit Country" : "Add Country"}</Title>}
      visible={open}
      okText={editable ? "Save" : "Modify"}
      onCancel={() => {
        resetFields();
        close();
      }}
      okButtonProps={{ loading, disabled: !modify && !editable }}
      onOk={() => (editable ? handleSubmit() : setEditable(true))}
    >
      <Form layout="vertical">
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Country Name</Text>} colon={false} required>
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Please enter country name!" }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter Country Name (e.g. India)"
                  maxLength={100}
                />
              )}
            </Item>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Sort Name / Code</Text>} colon={false}>
              {getFieldDecorator("sortName", {
                rules: [{ required: false }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter Country Short Code (e.g. IN)"
                  maxLength={20}
                />
              )}
            </Item>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span={24}>
            <Item label={<Text strong>Phone Code</Text>} colon={false}>
              {getFieldDecorator("phoneCode", {
                rules: [{ required: false }],
              })(
                <Input
                  disabled={!editable}
                  placeholder="Enter Country Phone Code (e.g. +91)"
                  maxLength={20}
                />
              )}
            </Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const WrappedCountryModal = Form.create({ name: "country_form" })(CountryForm);

export default WrappedCountryModal;
